/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Target_Not_FoundInputs */



/**
* | output |
* | --- |
* | "The endpoint does not offer this model." |
*
* @param {Private_Models_Hint_Target_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_target_not_found = /** @type {((inputs?: Private_Models_Hint_Target_Not_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Target_Not_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Endpunkt bietet dieses Modell nicht an.")
	return /** @type {LocalizedString} */ ("The endpoint does not offer this model.")
});